<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label
    for="pharmacyGovernorate"
    class="text-[14px] font-[500] hover:cursor-pointer"
    i18n="@@pharmacyAddressGovernorate">
    Governorate
    <span class="text-danger-text">*</span>
  </label>
  <select
    (change)="onChangeGovernorate()"
    formControlName="pharmacyGovernorate"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacyGovernorate')?.invalid && pharmacyForm().get('pharmacyGovernorate')?.touched
    ">
    <option disabled value="" i18n="@@selectGovernorate">Select Governorate</option>
    @for (governorate of governorates(); track governorate.id) {
      <option [value]="governorate.id">
        {{ isArabic() ? governorate.titleAr : isEnglish() ? governorate.titleEn : "" }}
      </option>
    }
  </select>

  @if (pharmacyForm().get("pharmacyGovernorate")?.invalid && pharmacyForm().get("pharmacyGovernorate")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacyGovernorate")?.errors?.["required"]) {
        <span i18n="@@governorateRequired">Governorate is required</span>
      }
    </span>
  }
</div>
